/*
 * Copyright (c) 2019 LNBIG.com
 * All rights reserved.
 */

import glue from '@/CommandGlue'
import dbg  from "debug";
const debug = dbg('lnbig:store:main')

export default {
    namespaced: true,
    state: {
        userID: null
    },

    mutations: {
        // Отрабатывается, когда по сокету от сервера приходит эта команда после команды cmdHello
        cmdYouAreUserID(state, message) {
            glue.find('cmdYouAreUserID', message, (message) => { debug('cmdYouAreUserID...'); return state.userID = message.userID })
        }
    },

    actions: {
        // async func
        actHelloAndUserID({ state, rootState, commit }) {
            return glue.add(
                (uuid) => {
                    debug("p_3_1")
                    rootState.webSocket.sendObj({
                        command:   'cmdHello',
                        namespace: 'main',
                        userID:    state.userID,
                        uuid:      uuid
                    });
                    debug('Послали команду cmdHello на сервер, userID из хранилища: %s', state.userID)
                },
                'cmdYouAreUserID'
            )
        }
    }
};
